
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

var $5957c8c2dc108832$exports = {};

(parcelRequire("1hiTA")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"XdB14\",\"ShareAndRestrictDialog.1e03e901.js\",\"g35Ma\",\"cs.98ab0bc3.js\",\"6jn9l\",\"da.c00537a5.js\",\"1w7fH\",\"de.02be3b36.js\",\"6oBxf\",\"en-GB.af529a9d.js\",\"1TTQt\",\"en-US.c938c2db.js\",\"k2w8V\",\"en-XA.8657c5c2.js\",\"9DH1A\",\"en-XB.bc0847c4.js\",\"88qtk\",\"en-ZZ.347e8e5a.js\",\"loV6E\",\"es.f3ee697b.js\",\"3Afk1\",\"et.cf27390c.js\",\"3xvJH\",\"fi.9e719dc0.js\",\"eYO04\",\"fr.9b8a6025.js\",\"6GuZx\",\"hr.35ebecc9.js\",\"4Afn2\",\"hu.c8a255cc.js\",\"5t7J7\",\"it.7c29548d.js\",\"fPagA\",\"ja.fe26ae1a.js\",\"dsh71\",\"ko.20f4a518.js\",\"03jrX\",\"nb.1e50a5fd.js\",\"gebmR\",\"nl.bdec2c9c.js\",\"4YGt1\",\"pl.092e8416.js\",\"9amHO\",\"pt-BR.6c69a178.js\",\"42zva\",\"ro.079a2cc0.js\",\"cxvqH\",\"ru.3880cf58.js\",\"aEBds\",\"sl.23b7af36.js\",\"4QuXE\",\"sr-RS.e1da887a.js\",\"fZbef\",\"sr-YR.1a61d169.js\",\"hfdfW\",\"sr.ef83e66a.js\",\"cnTvB\",\"sv.1d6e04fb.js\",\"4zZgK\",\"th.4dc5d311.js\",\"lCDYE\",\"tr.e443f784.js\",\"3umn0\",\"uk.b9093a97.js\",\"eMrsH\",\"vi.299c0b24.js\",\"ffbcZ\",\"zh-CN.c0def321.js\",\"ifRct\",\"zh-TW.99c5f34c.js\"]"));


$parcel$global.rlb("3b8uf")
//# sourceMappingURL=ShareAndRestrictDialog.runtime.ea707cf3.js.map
